"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=1835%3A437))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 */
export const Graph = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M23.5399 5L16.4508 5C16.1747 5 15.9508 5.22386 15.9508 5.5C15.9508 5.77614 16.1747 6 16.4508 6H22.3328L13.1764 15.1564L13.175 15.1578C13.103 15.2277 13.0065 15.2668 12.9061 15.2668C12.8057 15.2668 12.7093 15.2277 12.6372 15.1578L8.56307 11.0837L8.56308 11.0836L8.55951 11.0801C8.3004 10.8262 7.95204 10.6839 7.58921 10.6839C7.22638 10.6839 6.87801 10.8262 6.6189 11.0801L6.61889 11.0801L6.61535 11.0837L0.146447 17.5526C-0.0488155 17.7478 -0.0488155 18.0644 0.146447 18.2597C0.341709 18.4549 0.658291 18.4549 0.853553 18.2597L7.32032 11.7929C7.39236 11.723 7.48879 11.6839 7.58921 11.6839C7.68962 11.6839 7.78605 11.723 7.85808 11.7929L11.9323 15.8671L11.9322 15.8671L11.9358 15.8706C12.1949 16.1246 12.5433 16.2668 12.9061 16.2668C13.2689 16.2668 13.6173 16.1246 13.8764 15.8706L13.8764 15.8706L13.88 15.8671L23.04 6.70702V12.5892C23.04 12.8654 23.2639 13.0892 23.54 13.0892C23.8162 13.0892 24.04 12.8654 24.04 12.5892V5.5C24.04 5.22386 23.8162 5 23.54 5L23.5399 5Z"
    fill="currentColor"
  />,
  "Graph",
  { viewBox: "0 0 25 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
